import { render, staticRenderFns } from "./withdrawal-history.vue?vue&type=template&id=47f970d8"
import script from "./withdrawal-history.vue?vue&type=script&lang=js"
export * from "./withdrawal-history.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports